const cx = (...args) => args.filter(Boolean).join(' ');

export default cx;
